
import { toast } from 'react-toastify';

export function cerrarSesion(logged) {
    localStorage.removeItem(process.env.REACT_APP_ID_EMPRESA);
    localStorage.removeItem(process.env.REACT_APP_ID_EVENTO);
    localStorage.removeItem(process.env.REACT_APP_ID_INSCRIPCION);
    localStorage.removeItem(process.env.REACT_APP_NOMBRE_EMPRESA);
    localStorage.removeItem(process.env.REACT_APP_FECHA_CIERRE);
    localStorage.removeItem(process.env.REACT_APP_ID_ACTIVIDAD);
    localStorage.removeItem(process.env.REACT_APP_WARNING_EDITAR_PERFIL);
    localStorage.removeItem(process.env.REACT_APP_MAIL_EMPRESA);
    localStorage.removeItem(process.env.REACT_APP_TOKEN);
    localStorage.removeItem(process.env.REACT_APP_FECHA_REFRESH);
    localStorage.removeItem(process.env.REACT_APP_DESDE_PERFIL);
    if (logged)
        document.location.href = '/';
}
export function arreglarReloj() {
    const encabezadosReloj = document.getElementsByClassName("time_picker_modal_header");
    for (var i = 0; i < encabezadosReloj.length; i++) {
        const hijos = encabezadosReloj[i].childNodes
        if (hijos.length > 2) {
            hijos[2].click();
            new Promise(resolve => setTimeout(resolve, 500)).then(() => {
                hijos[0].click();
            });
        }
    }
}
export function formatDateToInput(fecha) {
    if (!fecha) return "";
    const [dia, mes, anio] = fecha.split("/");
    return `${anio}-${mes}-${dia}`;
}
export function toastSuccess(mensaje) {
    toast.success(mensaje, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });
}
export function toastError(mensaje) {
    toast.error(mensaje, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });
}
export function toastWarning(mensaje) {
    toast.warning(mensaje, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });
}
export function toastInfo(mensaje) {
    toast.info(mensaje, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        icon: false
    });
}
export function toastWarningUnique(mensaje) {

    toast.warning(mensaje, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        toastId: 1
    });
}
export function toastErrorUniqueInfinite(mensaje) {

    toast.error(mensaje, {
        position: "top-right",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        toastId: 1
    });
}
export function toastInfoUniqueInfinite(mensaje, isLeft) {

    toast.info(mensaje, {
        position: isLeft ? "top-left" : "top-right",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        toastId: 2,
        style: isLeft ? {
            width: "405px"
        } : { width: "405px", position: "absolute", right: '0' }
    });
}
export function handleError(error) {
    if (error && error.isAxiosError) {
        if (!error.response) {
            return "Lo sentimos, pero ocurrió un problema inesperado en el servidor."
        }
        const status = error.response.status
        if (status === 0) {
            return "Lo sentimos, pero ocurrió un problema inesperado en el servidor."
        } else if (status === 404 || status === 400 || status === 401 || status === 403) {
            if (error.response.data.message !== undefined)
                return error.response.data.message
            else if (error.response.data.msg !== undefined)
                return error.response.data.msg
            else
                return error.response.data
        }
        else
            return 'Lo sentimos, pero ocurrió un problema inesperado en el servidor.'
    }
}

const aplicarFormatoPagina = (width, height) => {
    if (!width || !height) return null;

    const style = document.createElement("style");
    style.id = "printMesaPageStyle";
    style.innerHTML = `
        @page {
            size: ${width} ${height};
            margin: 0;
        }
    `;
    document.head.appendChild(style);

    return style;
};

export const imprimirSeccion = ({ idSeccion, width, height, printFooter = true }) => {
    const seccion = document.getElementById(idSeccion);
    const footer = document.getElementById("footer");

    if (!seccion) return;

    const stylePage = aplicarFormatoPagina(width, height);

    seccion.classList.add("visible");

    if (!printFooter && footer) footer.classList.add("d-none");

    setTimeout(() => {
        window.print();

        seccion.classList.remove("visible");
        if (!printFooter && footer) footer.classList.remove("d-none");

        if (stylePage) stylePage.remove();
    }, 50);
};

